<template>
	<el-dialog
		title="修改密码"
		:visible.sync="visible"
		:rules="rules"
		:close-on-click-modal="false"
		class="edit-password edit-dialog dialog-module"
	>
		<p class="prompt" @click="showPwdRule">查看密码规则</p>
		<el-form :model="form" :rules="rules" ref="form">
			<el-form-item
				label="旧密码"
				:label-width="labelWidth"
				prop="oldPwd"
			>
				<el-input
					v-model="form.oldPwd"
					autocomplete="off"
					class="inpt"
					:type="showPwd.one ? 'text' : 'password'"
				>
					<i
						slot="suffix"
						class="input__icon iconfont cursor"
						@click="changeShowPwd('one')"
						:class="{
							'icon-bukejian': !showPwd.one,
							'el-icon-view': showPwd.one,
						}"
					></i>
				</el-input>
			</el-form-item>
			<el-form-item
				label="新密码"
				:label-width="labelWidth"
				prop="newPwd"
			>
				<el-input
					v-model="form.newPwd"
					autocomplete="off"
					class="inpt"
					:type="showPwd.two ? 'text' : 'password'"
				>
					<i
						slot="suffix"
						@click="changeShowPwd('two')"
						class="input__icon iconfont cursor"
						:class="{
							'icon-bukejian': !showPwd.two,
							'el-icon-view': showPwd.two,
						}"
					></i>
				</el-input>
			</el-form-item>
			<el-form-item
				label="确认密码"
				:label-width="labelWidth"
				prop="confirmPwd"
			>
				<el-input
					v-model="form.confirmPwd"
					autocomplete="off"
					class="inpt"
					:type="showPwd.three ? 'text' : 'password'"
				>
					<i
						slot="suffix"
						@click="changeShowPwd('three')"
						class="input__icon iconfont cursor"
						:class="{
							'icon-bukejian': !showPwd.three,
							'el-icon-view': showPwd.three,
						}"
					></i>
				</el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="submit">确定</el-button>
			<el-button @click="visible = false">取消</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: "EditPassword",
		data() {
			return {
				form: {
					oldPwd: "",
					newPwd: "",
					confirmPwd: "",
				},
				labelWidth: "91px",
				visible: false,
				rules: {
					oldPwd: [
						{
							required: true,
							message: "请输入旧密码",
							trigger: "blur",
						},
					],
					newPwd: [
						{
							required: true,
							message: "请输入新密码",
							trigger: "blur",
						},
						{
							message:
								"密码必须8位以上并且包含大小写字母数字和特殊符号!",
							type: "string",
							pattern:
								/^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
							trigger: "blur",
						},
					],
					confirmPwd: [
						{
							required: true,
							message: "请输入确认密码",
							trigger: "blur",
						},
						{
							message:
								"密码必须8位以上并且包含大小写字母数字和特殊符号!",
							type: "string",
							pattern:
								/^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
							trigger: "blur",
						},
					],
				},
				showPwd: {
					//展示pwd
					one: false,
					two: false,
					three: false,
				},
			};
		},
		props: {},
		methods: {
			// 清除输入的值
			clearVals() {
				for (let key in this.form) {
					this.form[key] = "";
				}
			},
			// 控制显示密码
			changeShowPwd(key) {
				this.showPwd[key] = !this.showPwd[key];
			},
			// 显示密码规则
			showPwdRule() {
				this.$alert(
					"密码必须8位以上并且包含大小写字母数字和特殊符号!",
					"密码规则",
					{
						confirmButtonText: "确定",
					}
				);
			},
			checkVals() {
				let flag = false;
				this.$refs["form"].validate((valid) => {
					if (valid) {
						flag = true;
					} else {
						console.log("校验有问题");
						return false;
					}
				});
				return flag;
			},
			// 提交修改密码
			submit() {
				if (!this.checkVals()) {
					return false;
				}
				if (this.form.newPwd !== this.form.confirmPwd) {
					this.$message.error("新密码与确认密码不一致");
					this.form.confirmPwd = "";
					return false;
				}
				let p = {
					oldPassword: this.form.oldPwd,
					newPwd: this.form.newPwd,
				};
				this.axios
					.post(this.getApiUrl("updatePwd"), p)
					.then((res) => {
						if (res.code === 1) {
							this.$message.success("修改成功");
							// 清除并重置结果
							this.$refs.form.resetFields();
							// 关闭弹窗
							this.visible = false;
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("修改密码失败");
						console.log(err);
					});
			},
			// 清楚校验结果
			clearValidate() {
				this.$refs.form.clearValidate();
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "@/assets/css/color.scss";
	.inpt {
		width: 363px;
	}
	.prompt {
		position: absolute;
		right: 32px;
		top: 37px;
		cursor: pointer;
	}
	.el-icon-view {
		// padding-top: 5px;
		font-size: 15px;
	}
	.input__icon {
		line-height: 40px;
	}
</style>
